import { media, useMediaQuery } from '@utilitywarehouse/hearth-react';
import LogoWhiteMobile from '@utilitywarehouse/hearth-svg-assets/lib/logo-condensed-warm-white.svg';
import LogoWhite from '@utilitywarehouse/hearth-svg-assets/lib/logo-full-warm-white.svg';

import './styles.scss';

interface LogoProps {
  onClick: () => void;
  isClickable?: boolean;
}

const Logo = ({ onClick, isClickable = true }: LogoProps) => {
  const isDesktop = useMediaQuery(media.above('desktop'));

  const image = (
    <img
      src={isDesktop ? LogoWhite : LogoWhiteMobile}
      alt="Utility Warehouse logo"
      className="layout-header__logo"
    />
  );

  if (!isClickable) {
    return image;
  }

  return (
    <button
      type="button"
      className="layout-header__logoButton"
      data-testid="header-logo-button"
      onClick={onClick}
    >
      {image}
    </button>
  );
};

export type { LogoProps };
export { Logo };
